import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {Subject} from 'rxjs';
import '@angular/localize/init';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class MyCustomPaginatorIntl extends MatPaginatorIntl {
    translateService: TranslateService;
    changes = new Subject<void>();
    getRangeLabel = function (page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return $localize` ${this.translateService.instant('COMPONENTS.PAGINATOR.page')} 1 ${this.translateService.instant('COMPONENTS.PAGINATOR.of')} 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return $localize` ${this.translateService.instant('COMPONENTS.PAGINATOR.page')} ${page + 1} ${this.translateService.instant('COMPONENTS.PAGINATOR.of')} ${amountPages}`;
    }

    injectTranslateService(translate: TranslateService) {
        this.translateService = translate;
        this.translateService.onLangChange.subscribe(() => {
            this.translateLabels();
        });
        this.translateLabels();
    }

    translateLabels() {
        this.itemsPerPageLabel = this.translateService.instant('COMPONENTS.PAGINATOR.itemsPerPageLabel');
        this.nextPageLabel = this.translateService.instant('COMPONENTS.PAGINATOR.nextPageLabel');
        this.previousPageLabel = this.translateService.instant('COMPONENTS.PAGINATOR.previousPageLabel');
        this.changes.next();
    }
}
